import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Label, Input, NavbarBrand } from 'reactstrap';
import '../css/Login.css';
import '../css/OverlayLoader.css';
import { validateSecureCodeService, confirmChangePasswordService, userResponseService } from '../../api/userapi';
import { Container } from 'reactstrap';
import { Redirect } from "react-router-dom";
import { customLoadingOverlay } from '../css/CustomLoadingOverlay'
import LoadingOverlay from 'react-loading-overlay-ts'

class Changepassword extends React.Component {
    constructor(props) {
        super(props);
        let code = '';
        if (this.props.route.match.params)
            code = this.props.route.match.params.code;
        this.state = {
            password: '',
            confirmPassword: '',
            code: code,
            passwordHidden1: true,
            passwordHidden2: true,
            classNamePasswordEye1: 'fa fa-eye-slash',
            classNamePasswordEye2: 'fa fa-eye-slash',
            submitted: false,
            loading: false,
            success: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.toSignIn = this.toSignIn.bind(this);
        this.toggleShow1 = this.toggleShow1.bind(this);
        this.toggleShow2 = this.toggleShow2.bind(this);
    }

    componentDidMount() {
        this.props.validateSecureCodeConnect(this.state.code);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.userReponse !== null) {
            if (prevProps.userReponse.data) {
                if (prevProps.userReponse.data.success == true) {
                    this.props.userResponseConnect(null);
                    this.setState({ loading: false });
                    return;
                }
            }
        }

        if (this.props.userReponse !== null) {
            if (this.props.userReponse.data) {
                if (this.props.userReponse.data.success && prevState.loading) {
                    this.setState({ loading: false, success: true });
                }
            }
        }

        if (this.props.userReponse !== null) {
            if (this.props.userReponse.data) {
                if (!this.props.userReponse.data.success && prevState.loading) {
                    this.setState({ loading: false });
                }
            }
        }
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }


    handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { password, confirmPassword } = this.state;
        if (password !== confirmPassword)
            return;
        if (password && confirmPassword) {
            if (this.props.validateSecureCodeReponse) {
                this.setState({ loading: true });
                const userPasswordChange = {
                    email: this.props.validateSecureCodeReponse.data.data.email,
                    secureCode: this.state.code,
                    password: password,
                    tAndC: true
                };
                this.props.confirmChangePasswordConnet(userPasswordChange);
            }
        }
    }

    handleRedirect = () => {
        this.setState({
            redirect: true
        })
    }

    toggleShow1(e) {
        e.preventDefault();
        let hidden = !this.state.passwordHidden1;
        let className = '';
        if (hidden)
            className = 'fa fa-eye-slash';
        else
            className = 'fa fa-eye';
        this.setState({ passwordHidden1: hidden, classNamePasswordEye1: className });
    }

    toggleShow2(e) {
        e.preventDefault();
        let hidden = !this.state.passwordHidden2;
        let className = '';
        if (hidden)
            className = 'fa fa-eye-slash';
        else
            className = 'fa fa-eye';
        this.setState({ passwordHidden2: hidden, classNamePasswordEye2: className });
    }

    toSignIn() {
        this.props.userResponseConnect(null);
        this.props.route.history.push('/');
    }

    render() {
        const { password, confirmPassword, submitted, loading, success } = this.state;

        if (this.state.redirect) {
            return <Redirect
                to={{
                    pathname: `/forgotpassword`,
                }}
            />;
        }


        let userReponse = this.props.userReponse;
        let validateSecureCodeReponse = this.props.validateSecureCodeReponse;

        let messages = '';
        if (userReponse) {
            if (userReponse.data) {
                if (!userReponse.data.success) {
                    if (userReponse.data.errors) {
                        messages = userReponse.data.errors.map((item) =>
                            <li key={item.errorCode} >{item.message}</li>
                        );
                    }
                }
            }
        }

        if (validateSecureCodeReponse) {
            if (validateSecureCodeReponse.data) {
                if (!validateSecureCodeReponse.data.success) {
                    if (validateSecureCodeReponse.data.errors) {
                        messages = validateSecureCodeReponse.data.errors.map((item) =>
                            <li key={item.errorCode} >{item.message}</li>
                        );

                        return (<Container>
                            <div className="col-md-12">
                                <br></br> <br></br>
                                <br></br> <br></br>
                                <div className="d-flex justify-content-center">
                                    <NavbarBrand tag={Link} to="/"><img src="./aaa_logo.png" alt="logo" className="title-logo" /></NavbarBrand>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <h5 className="title-login-logo"> GIFT CENTER PORTAL </h5>
                                </div>
                                <br></br>
                                <div className="d-flex justify-content-center">
                                    <br></br>
                                    <ul className="errors-list-forgot">{messages}</ul>
                                </div>
                                <div className="form-group">
                                    <div className="d-flex justify-content-center">
                                        <button onClick={this.handleRedirect} className="btn mt-4">REQUEST PASSWORD RESET</button>
                                    </div>
                                </div>
                            </div>
                        </Container>);
                    }
                }
            }
        }

        return (
            <Container>
                <LoadingOverlay active={loading} spinner styles={customLoadingOverlay} >
                    <div className="col-md-12">
                        <br></br> <br></br>
                        <br></br> <br></br>
                        <div className="d-flex justify-content-center">
                            <NavbarBrand tag={Link} to="/"><img src="./aaa_logo.png" alt="logo" className="title-logo" /></NavbarBrand>
                        </div>
                        <div className="d-flex justify-content-center">
                            <h5 className="title-login-logo"> GIFT CENTER PORTAL </h5>
                        </div>
                        <br></br>
                        <div className="d-flex justify-content-center">
                            {!success && <Form name="form" onSubmit={this.handleSubmit} className="col-md-5 user-text">
                                <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                    <Label className='mt-4' htmlFor="password"> <strong>Password</strong></Label>
                                    <div className="input-group" id="show_hide_password">
                                        <Input type={this.state.passwordHidden1 ? "password" : "text"}
                                            name="password"
                                            className='input-editable'
                                            value={password}
                                            onChange={this.handleChange} />
                                        <div className="input-group-addon eye-pass">
                                            <Link to='#' onClick={this.toggleShow1} ><i className={this.state.classNamePasswordEye1} aria-hidden="true"></i></Link>
                                        </div>
                                    </div>
                                    {submitted && !password &&
                                        <span className="help-block">Value is required.</span>
                                    }
                                </div>
                                <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                    <Label className='mt-4' htmlFor="confirmPassword"> <strong>Confirm Password</strong></Label>
                                    <div className="input-group" id="show_hide_password">
                                        <Input type={this.state.passwordHidden2 ? "password" : "text"}
                                            name="confirmPassword"
                                            className='input-editable'
                                            value={confirmPassword}
                                            onChange={this.handleChange} />
                                        <div className="input-group-addon eye-pass">
                                            <Link to='#' onClick={this.toggleShow2} ><i className={this.state.classNamePasswordEye2} aria-hidden="true"></i></Link>
                                        </div>
                                    </div>
                                    {submitted && !confirmPassword &&
                                        <div> <span className="help-block">Value is required.</span> </div>
                                    }
                                    {submitted && password != confirmPassword && confirmPassword &&
                                        <div> <span className="help-block"> Password confirmation does not match</span> </div>
                                    }
                                    <ul className="errors-list-forgot">{messages}</ul>
                                </div>
                                <div className="form-group">
                                    <div className="d-flex justify-content-center">
                                        <button className="btn mt-4" >SUBMIT</button>
                                    </div>
                                </div>
                            </Form>}
                            {
                                success && <div>
                                    <div className="text-center user-text">
                                        <p className="title-login-success">Your password was saved!</p>
                                    </div>
                                    <br></br>
                                    <div className="text-center user-text">
                                        <div className="d-flex justify-content-center">
                                            <button className="btn mt-4 sign" onClick={this.toSignIn}>SIGN IN</button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </LoadingOverlay>
            </Container>
        );
    }
}

export default connect(
    state => {
        return {
            userReponse: state.data.userReponse,
            validateSecureCodeReponse: state.data.validateSecureCodeReponse
        }
    },
    dispatch => ({
        validateSecureCodeConnect: (code) => { dispatch(validateSecureCodeService(code)) },
        confirmChangePasswordConnet: (userChangePassword) => { dispatch(confirmChangePasswordService(userChangePassword)) },
        userResponseConnect: (response) => { dispatch(userResponseService(response)) }
    })
)(Changepassword);